export const firebaseConfig = process.env.VUE_APP_PRODUCTION
  ? {
      apiKey: "AIzaSyDylvaPsuYpCxoWd5kMt7Rf-C_N-42FQbk",
      authDomain: "pool-calculator-1.firebaseapp.com",
      databaseURL: "https://pool-calculator-1.firebaseio.com",
      projectId: "pool-calculator-1",
      storageBucket: "pool-calculator-1.appspot.com",
      messagingSenderId: "29876903509",
    }
  : {
      apiKey: "AIzaSyD514wHZY8GXihapgOTzsCNK4Ur0Mw2pmg",
      authDomain: "pool-calculator-staging.firebaseapp.com",
      databaseURL: "https://pool-calculator-staging.firebaseio.com",
      projectId: "pool-calculator-staging",
    };
